import React from 'react';
import styles from '../../styles/wizards/LinkExistingFilesWizard.scss';
import { __ } from '../../core/utils';
import SearchIcon from '../../assets/images/search-15x15.svg';
import ToggleButton from '../../components/ToggleButton';
import FolderTree from './FolderTree';
import FilesList from './FilesList';

const FilesBrowser = ({ browser }) => (
  <>
    <div className={styles.toolbar}>
      <label className={styles.search}>
        <SearchIcon />
        <input
          type='text'
          value={browser.searchValue}
          onChange={(event) => browser.search(event.target.value)}
          placeholder={__(
            'files.wizard.search-project-files',
            {},
            'Search project files...',
          )}
        />
      </label>
      <div className={styles.showArchived}>
        <span>{__('files.wizard.show-archived', {}, 'Show archived')}</span>
        <ToggleButton
          value={browser.showArchived}
          onToggle={browser.toggleArchived}
        />
      </div>
    </div>

    <div className={styles.content}>
      <FolderTree
        folders={browser.folders}
        expandedFolderIds={browser.expandedFolderIds}
        activeFolderId={browser.activeFolderId}
        allFilesTotal={browser.allFilesTotal}
        unallocatedCount={browser.unallocatedCount}
        onSelectAll={browser.selectAllFiles}
        onSelectFolder={browser.selectFolder}
        onSelectUnallocated={browser.selectUnallocated}
        onToggleFolder={browser.toggleFolder}
      />
      <FilesList
        files={browser.files}
        loading={browser.loading}
        selectedFileIds={browser.selectedFileIds}
        selectablePageFileIds={browser.selectablePageFileIds}
        allPageSelected={browser.allPageSelected}
        isAlreadyLinked={browser.isAlreadyLinked}
        onToggleFile={browser.toggleFile}
        onTogglePageFiles={browser.togglePageFiles}
      />
    </div>
  </>
);

export default FilesBrowser;
